import { createSlice } from "@reduxjs/toolkit";

interface AccountInitialStateModel {
  userInfoes:any;
}
const accountInitialState: AccountInitialStateModel = {
  userInfoes:null
};

const profileSlice = createSlice({
  name: "accountSlice ",
  initialState: accountInitialState,
  reducers: {
    handleSetUserInfoes: (state, action) => {
      state.userInfoes = action.payload.data;
    },
   
    
  },
});

export const {
  handleSetUserInfoes,
} = profileSlice.actions;
export default profileSlice;
